import React from "react";

const PaymentType = ({ paymentType = null }) => {
  const type = {
    APP: "앱 (결제완료)",
    CARD: "카드",
    CASH: "현금",
  };
  return (
    <div className="tel">
      <span className="label">결제정보</span>
      <div>{type[paymentType] || "-"}</div>
    </div>
  );
};

export default PaymentType;
